(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clasp-edit"] && !Shopify.designMode) return;
  try {
    
 if (!customElements.get('clasp-home-motion')) {
  customElements.define('clasp-home-motion', class extends HTMLElement {
   connectedCallback() {
    this.disconnectedCallback();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.frame = requestAnimationFrame(() => {
    if (!this.isConnected) return;
    this.observer = new IntersectionObserver(entries => {
     for (const entry of entries) if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      this.observer.unobserve(entry.target);
     }
    }, { threshold: 0.08 });
    this.querySelectorAll('.clasp-edit__head, .clasp-card, .clasp-home-style, .clasp-story__inner, .clasp-home-help > a').forEach(item => {
     item.classList.add('clasp-home-reveal');
     this.observer.observe(item);
    });
    });
   }
   disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect();
    this.querySelectorAll('.clasp-home-reveal').forEach(item => item.classList.remove('clasp-home-reveal', 'is-visible'));
   }
  });
 }

if (!customElements.get('clasp-style-carousel')) {
 customElements.define('clasp-style-carousel', class extends HTMLElement {
  connectedCallback() {
   this.disconnectedCallback();
   this.lifecycle = new AbortController();
   this.autoEnabled = !this.hasAttribute('data-manual');
   this.hovered = false;
   this.held = false;
   this.visible = false;
   this.frame = requestAnimationFrame(() => {
    if (!this.isConnected) return;
    this.track = this.querySelector('.clasp-style-carousel__track');
    this.previous = this.querySelector('[data-carousel-previous]');
    this.next = this.querySelector('[data-carousel-next]');
    this.play = this.querySelector('[data-carousel-play]');
    if (!this.track || !this.previous || !this.next) return;
    const options = { signal: this.lifecycle.signal };
    this.previous.addEventListener('click', () => this.move(-1), options);
    this.next.addEventListener('click', () => this.move(1), options);
    this.play?.addEventListener('click', () => {
     this.autoEnabled = !this.autoEnabled;
     this.play.setAttribute('aria-label', this.autoEnabled ? this.play.dataset.pauseLabel : this.play.dataset.playLabel);
     this.play.setAttribute('aria-pressed', String(!this.autoEnabled));
     this.play.dataset.paused = String(!this.autoEnabled);
     this.schedule();
    }, options);
    this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
    this.addEventListener('focusin', () => this.schedule(), options);
    this.addEventListener('focusout', () => { queueMicrotask(() => { if (this.isConnected) this.schedule(); }); }, options);
    this.track.addEventListener('pointerdown', () => { this.held = true; this.stopAnimation(); this.schedule(); }, options);
    window.addEventListener('pointerup', () => { this.held = false; this.schedule(); }, options);
    window.addEventListener('pointercancel', () => { this.held = false; this.schedule(); }, options);
    this.track.addEventListener('wheel', () => { this.stopAnimation(); this.schedule(); }, { ...options, passive: true });
    this.track.addEventListener('scroll', () => {
     if (this.scrollFrame) return;
     this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.update(); });
    }, { ...options, passive: true });
    this.track.addEventListener('keydown', event => {
     if (event.target !== this.track) return;
     if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
     } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.track.scrollWidth - this.track.clientWidth);
     }
    }, options);
    document.addEventListener('visibilitychange', () => {
     if (document.hidden) this.stopAnimation();
     this.schedule();
    }, options);
    if ('IntersectionObserver' in window) {
     this.visibilityObserver = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      if (!this.visible) this.stopAnimation();
      this.schedule();
     }, { threshold: 0.3 });
     this.visibilityObserver.observe(this);
    } else this.visible = true;
    if ('ResizeObserver' in window) {
     this.resizeObserver = new ResizeObserver(() => { this.stopAnimation(); this.update(); this.schedule(); });
     this.resizeObserver.observe(this.track);
    } else window.addEventListener('resize', () => { this.update(); this.schedule(); }, options);
    this.update(); this.schedule();
   });
  }
  update() {
   const position = Math.abs(this.track.scrollLeft);
   const maximum = this.track.scrollWidth - this.track.clientWidth;
   this.previous.disabled = position <= 2;
   this.next.disabled = position >= maximum - 2;
  }
  schedule() {
   clearTimeout(this.autoTimer);
   if (!this.track || !this.isConnected || !this.autoEnabled || !this.visible || this.hovered || this.held || document.hidden || this.contains(document.activeElement) || this.animationFrame) return;
   if (this.track.scrollWidth - this.track.clientWidth <= 2) return;
   this.autoTimer = setTimeout(() => {
    const maximum = this.track.scrollWidth - this.track.clientWidth;
    if (Math.abs(this.track.scrollLeft) >= maximum - 2) this.go(0);
    else this.move(1);
   }, 4500);
  }
  move(direction) {
   const cards = this.track.children;
   const step = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : this.track.clientWidth;
   this.go(Math.abs(this.track.scrollLeft) + direction * step);
  }
  go(position) {
   this.stopAnimation(); clearTimeout(this.autoTimer);
   const maximum = this.track.scrollWidth - this.track.clientWidth;
   const target = Math.max(0, Math.min(maximum, position));
   const start = Math.abs(this.track.scrollLeft);
   const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
   let started;
   const tick = timestamp => {
    if (!this.isConnected) return;
    started ??= timestamp;
    const progress = Math.min(1, (timestamp - started) / 700);
    const eased = progress * progress * (3 - 2 * progress);
    this.track.scrollLeft = sign * (start + (target - start) * eased);
    if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
    else { this.animationFrame = 0; this.update(); this.schedule(); }
   };
   this.animationFrame = requestAnimationFrame(tick);
  }
  stopAnimation() { cancelAnimationFrame(this.animationFrame); this.animationFrame = 0; }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame);
   this.scrollFrame = 0;
   this.stopAnimation(); clearTimeout(this.autoTimer);
   this.lifecycle?.abort(); this.resizeObserver?.disconnect(); this.visibilityObserver?.disconnect();
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
